import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";
import media from "styled-media-query";

const screenSize1: any = "1350px";
const screenSize2: any = "1024px";

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: var(--doc-width);
	background-position: right;
	background-repeat: no-repeat;
	background-size: cover;
	${media.lessThan("medium")`
        width: unset;
    `}
`;
const Section = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	flex-direction: row;
	max-width: 1280px;
	padding: 80px 150px;
	height: 100%;
	${media.lessThan(screenSize1)`
        padding: 80px 65px;
    `}
	${media.lessThan(screenSize2)`
        padding: 80px 48px;
    `}
    ${media.lessThan("medium")`
        padding: 64px 32px;
		flex-direction: column;
    `}
    ${media.lessThan("small")`
        padding: 64px 24px;
    `}
`;

const ContainerSection = ({
	children,
	style,
	...props
}: ContainerSectionProps) => {
	return (
		<Container
			{...props}
			style={{
				backgroundColor: style?.backgroundColor,
				backgroundImage: props.backgroundImage,
			}}
		>
			<Section style={{ ...style, backgroundColor: "transparent" }}>
				{children}
			</Section>
		</Container>
	);
};
export default ContainerSection;
export interface ContainerSectionProps extends ComponentPropsWithoutRef<"div"> {
	backgroundImage?: string;
}
